export default __webpack_public_path__ + "static/media/typescript.7f228a7b.svg";